import React from "react";
import { Link } from "react-router-dom";
import { FiArrowUpRight } from "react-icons/fi";
import "../css/policy-hub.scss";
import siteConfig from "../config/siteConfig";

export const policyLinks = [
  ["Privacy policy", "/privacy", "Data collected by the storefront and Stripe hand-off."],
  ["Consumer data rights", "/data-rights", "Access, correction, deletion and verification."],
  ["Cookie & storage notice", "/cookies", "Local storage, session storage and Stripe pages."],
  ["Terms of sale & use", "/terms", "Orders, catalogue use and mandatory rights."],
  ["Shipping policy", "/shipping", "Fixed charge, addresses and preparation."],
  ["Delivery issues", "/delivery-issues", "Lost, delayed, damaged or incorrect parcels."],
  ["Returns & refunds", "/returns", "Window, condition, assessment and refund route."],
  ["Order cancellation", "/cancellations", "Changes before preparation or dispatch."],
  ["International orders", "/international-orders", `${siteConfig.business.currency}, duties and border uncertainty.`],
  ["Payment, pricing & fraud", "/payments", "Stripe redirection and verified status."],
  ["Discounts & promotions", "/promotions", "The code the cart actually accepts."],
  ["Sale & final sale", "/sale-items", "Reduced prices without a hidden final-sale rule."],
  ["Product information", "/product-information", "Colour, material, fit and natural variation."],
  ["Product care & safety", "/care-safety", "Material care and garment-use cautions."],
  ["Reviews & user content", "/reviews-content", "Current absence and future standards."],
  ["Intellectual property", "/intellectual-property", "Original assets and rights notices."],
  ["Accessibility", "/accessibility", "Access measures, limits and reporting."],
  ["Packaging & sustainability", "/packaging", "Protection and evidence-based claims."],
  ["Complaints & disputes", "/complaints", "Evidence, review and escalation."],
  ["Policy updates", "/policy-updates", "When operational changes require a rewrite."],
  ["Pre-order policy", "/pre-orders", "Payment, estimates and cancellation."],
  ["FAQ", "/faq", "Current checkout and service answers."],
];

export default function PolicyHub() {
  return (
    <main className="policy-hub page-shell">
      <header><p className="eyebrow">{siteConfig.brandName} / customer care</p><h1>Policies,<br />without the small print.</h1><p>Twenty-two focused documents map the products and shopping flow that actually exist.</p></header>
      <div className="policy-hub__grid">
        {policyLinks.map(([label, to, copy], index) => (
          <Link key={to} to={to}><span>{String(index + 1).padStart(2, "0")}</span><h2>{label}</h2><p>{copy}</p><FiArrowUpRight /></Link>
        ))}
      </div>
    </main>
  );
}
